export const deepCopy = <T>(obj: T): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  return JSON.parse(JSON.stringify(obj));
};
